<template>
  <div>
    <div class="app-head">
      <div>
        <h4 class="app-title">学习统计</h4>
        <div class="app-desc">统计资源学习情况。</div>
      </div>
    </div>
    <div class="app-form">
      <div class="course">
        <el-alert v-if="!list.length" type="error" :closable="false">~还没有发布学习资源</el-alert>
        <div class="course-stat">
          <div class="item pointer" @click="showCourse">资源数<div class="count">5</div></div>
          <div class="item">学时数<div class="count">650</div></div>
          <div class="item pointer" @click="showStu">学生数<div class="count">80</div></div>
        </div>
        <el-card class="course-item">
          <ve-pie :data="chartData" :title="{text:'资源学习情况'}"></ve-pie>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import 'echarts/lib/component/title';
import VePie from 'v-charts/lib/pie.common';
export default {
  mixins: [tools],
  components: { VePie },
  data () {
    return {
      loading: false,
      page: 1,
      total: 0,
      list: [],
      chartData: {
        columns: ['课程', '学习用户'],
        rows: [
          { '课程': '课程1', '学习用户': 1393 },
          { '课程': '课程2', '学习用户': 3530 },
          { '课程': '课程3', '学习用户': 2923 },
          { '课程': '课程4', '学习用户': 1723 },
          { '课程': '课程5', '学习用户': 3792 },
          { '课程': '课程6', '学习用户': 4593 }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      reloadCourse: [types.ORGANIZATION.reloadCourse]
    }),
  },
  watch: {
    reloadCourse() {
      this.loadData();
    }
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.list.length) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      if (this.loading || !this.hasPermiss('weborg.course.query')) {
        return;
      }
      this.loading = true;
      this.doPost({
        url: 'vue/organization/course',
        data: Object.assign({page: this.page}, this.searchData),
        okcb: (json) => {
          this.list = json.list;
          this.page = json.pageNumber;
        },
        cb: () => {
          this.$nextTick(() => this.loading = false);
        }
      });
    },
    showCourse() {
      this.$router.push('/course-list');
    },
    showStu() {
      this.$router.push('/course-stu');
    },
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    margin-bottom:2rem;
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
}
.course {
  &-stat {
    .flex-center-v();
    justify-content:space-between;
    margin-bottom:2rem;
    background-color:#fff;
    .shadow-black(0 0 5px 0, .05);
    .item {
      &.pointer {
        cursor:pointer;
        &:hover {
          background-color:#f8f8f8;
        }
      }
      flex:33%;
      padding:2rem;
      text-align:center;
      .count {
        font-size:2rem;
      }
    }
  }
  &-item {
    margin-bottom:2rem;
  }
}
</style>